import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchProducts = () => axios.get(`${API}/products`).then((r) => r.data);
export const fetchPrices = () => axios.get(`${API}/product-prices`).then((r) => r.data);
export const fetchTemplates = () => axios.get(`${API}/templates`).then((r) => r.data);
export const fetchShippingZones = () =>
  axios.get(`${API}/shipping-zones`).then((r) => r.data);
export const fetchQuote = (payload) =>
  axios.post(`${API}/quote`, payload).then((r) => r.data);

export const uploadLogo = (file) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/logo`, form, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

/** Absolute URL for a stored logo, usable directly in <img src>. */
export const createOrder = (payload) =>
  axios.post(`${API}/orders`, payload).then((r) => r.data);

export const logoUrl = (storagePath) =>
  storagePath ? `${API}/logo/${storagePath}` : null;

export const initPayment = (payload) =>
  axios.post(`${API}/payments/toyyibpay/create`, payload).then((r) => r.data);

export const fetchPaymentStatus = (orderReference) =>
  axios
    .get(`${API}/payments/status/${encodeURIComponent(orderReference)}`)
    .then((r) => r.data);
